import { useRef } from 'react';
import PropTypes from 'prop-types';
import useModalA11y from '../../../hooks/useModalA11y';
import { SUPPORT_EMAIL } from '../../../utils/constants/subscription';

// Native <dialog> (TD-2120 Item 2): opened via showModal() in useModalA11y, so
// focus trap, Escape, aria-modal, top-layer and ::backdrop come from the
// platform. The dialog element carries no padding (see usage-metrics.less) so a
// backdrop click resolves to the <dialog> itself and the hook treats it as a
// light-dismiss; the inner .fallback-modal-dialog holds the visible box.
const FallbackActivationModal = ({ isOpen, onClose }) => {
  const dialogRef = useRef(null);
  useModalA11y({ isOpen, onClose, dialogRef });

  if (!isOpen) return null;

  return (
    <dialog
      ref={dialogRef}
      className="fallback-modal"
      aria-labelledby="fallback-modal-title"
      aria-describedby="fallback-modal-info"
    >
      <div className="fallback-modal-dialog">
        <h3 id="fallback-modal-title" className="fallback-modal-title">
          Weekly Token Limit Reached
        </h3>
        <div className="fallback-modal-info" id="fallback-modal-info">
          <p>
            <strong>Fallback model activated.</strong> Your company&apos;s weekly token limit has
            been reached. The system has automatically switched to Haiku 4.5 until Monday.
          </p>
          <p>Your total token pool is still available. Full model performance resumes next week.</p>
          <p>
            To increase your weekly limit, contact your sales team:{' '}
            <a
              className="fallback-modal-support-link"
              href={`mailto:${SUPPORT_EMAIL}`}
              aria-label={`Email support at ${SUPPORT_EMAIL}`}
            >
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>
        <div className="fallback-modal-actions">
          <a
            className="fallback-modal-btn-secondary"
            href={`mailto:${SUPPORT_EMAIL}`}
            aria-label={`Email support at ${SUPPORT_EMAIL}`}
          >
            Contact Support
          </a>
          <button type="button" className="fallback-modal-btn-primary" onClick={onClose}>
            Continue with Fallback
          </button>
        </div>
      </div>
    </dialog>
  );
};

FallbackActivationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default FallbackActivationModal;
